import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const skuValidator =
  (): ValidatorFn =>
  (control: AbstractControl<string>): ValidationErrors | null => {
    const value = control.value;

    const allowedSkuLength = 30; // online articles have max 20, but there are a couple of offline articles with lengths of 30 characters so whatevs
    const specialSkus = ['Koerier', 'XKosten'];

    if (!value || specialSkus.includes(value)) {
      return null;
    }

    if (value.length < 1 || value.length > allowedSkuLength) {
      return { invalidLength: 'SKU must be between 1 and 30 characters.' };
    }

    if (!/^[A-Z0-9]*$/.test(value)) {
      return {
        invalidFormat: 'SKU must be uppercase and contain only letters and numbers.',
      };
    }

    return null;
  };

export const SKUValidator = skuValidator();
